import { Ng2StateDeclaration } from '@uirouter/angular';
import { AdminDashboardComponent } from '@client/app/feature-modules/admin/modules/admin-dashboard/components/admin-dashboard.component';

export const AdminDashboardStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin.dashboard',
        url: '/dashboard',
        component: AdminDashboardComponent,
        data: {
            title: 'Acquia Web Governance - Dashboard',
            /** Shell-facing path for CC breadcrumb/menu sync (see event-bus-bridge.init.ts) */
            shellPath: '/admin/dashboard',
            // '/admin' is the CC menu route — alias it so incoming shell navigation
            // resolves here (outgoing always emits the real full path above).
            shellAliases: ['/admin'],
        },
    },
];
